import Immutable from 'immutable';

const defaultState = Immutable.Map();

export default function reducer(state = defaultState) {
  return state;
}
